import { loan_application_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { useContext } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  applicationKeys,
  parseApplicationKey,
} from '../cache-keys/applicationKeys';
import { queryFunction } from '../query-function';

export type LoanApplicationData = Awaited<
  ReturnType<ReturnType<typeof loan_application_api.getLoanApplication>>
>;
export type LoanApplicationQueryKey = ReturnType<typeof applicationKeys.root>;

export type UseLoanApplicationParams = {
  id: string | null;
};

export type UseLoanApplicationOptions = Pick<
  UseQueryOptions<LoanApplicationData, Error, LoanApplicationData, string[]>,
  'enabled' | 'onSuccess' | 'onError'
>;

export function useLoanApplication(
  params: UseLoanApplicationParams = { id: null },
  options: UseLoanApplicationOptions = { enabled: true }
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();

  const cacheKey = applicationKeys.root({
    applicationID: params.id ?? '',
  });

  return useQuery({
    queryKey: cacheKey,
    queryFn: queryFunction<LoanApplicationQueryKey, any, LoanApplicationData>(
      loan_application_api.getLoanApplication(api),
      ({ queryKey }) => parseApplicationKey(queryKey).applicationID ?? ''
    ),
    ...options,
    enabled: !!state.user.token && !!params.id && options.enabled,
  });
}
